import {
    OPEN_CLOSE_MYOFFERS_LIST_MODAL,
    OPEN_CLOSE_GIFT_FOR_YOU_MODAL,
    OPEN_CLOSE_MYOFFERS_MODAL,
    OPEN_CLOSE_TERMS_AND_CONDITIONS_MODAL,
    SELECT_TC_PROMO_ID,DO_NOT_SHOW_CHECK
} from '../constants/actionTypes';

export default (state, action) => {
    switch (action.type) {
        case OPEN_CLOSE_MYOFFERS_LIST_MODAL:
            let newIsMyOffersListPopup = !state.isMyOffersListPopup;
            return {
                ...state,
                isMyOffersListPopup: newIsMyOffersListPopup
            };
        case OPEN_CLOSE_GIFT_FOR_YOU_MODAL:
            return {
                ...state,
                isGiftForYouOpen: !state.isGiftForYouOpen
            };
        case OPEN_CLOSE_MYOFFERS_MODAL:
            let newIsMyOffersPopup = !state.isMyOffersPopupOpen;
            return {
                ...state,
                isMyOffersPopupOpen: newIsMyOffersPopup,
                newPromoFlag:false
            };
        case OPEN_CLOSE_TERMS_AND_CONDITIONS_MODAL:
            return {
                ...state,
                isTermsAndConditionsPopupOpen: !state.isTermsAndConditionsPopupOpen
            };
        case SELECT_TC_PROMO_ID:
            let selectedTCPromoId = action.selectedTCPromoId;
            return {
                ...state,
                selectedTCPromoId: selectedTCPromoId
            };
        case DO_NOT_SHOW_CHECK:
            return {
                ...state,
                doNotShow:!state.doNotShow
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/promoBetReducer.js